import { useSelector } from "react-redux";

export const useMatchComplete = (matchId) => {
  const { matchings = [] } = useSelector(
    (state) => state.matches?.byId?.[matchId] || {}
  );
  return matchings.length > 0;
};
